import { lazy, Suspense } from "react";
import Footer from "./components/Footer";
import './styles.css';

const Header = lazy(() => import('./components/Header'));
const FirstLayer = lazy(() => import('./components/FirstLayer'));
const SecondLayer = lazy(() => import('./components/SecondLayer'));
const ThirdLayer = lazy(() => import('./components/ThirdLayer'));
const FourthLayer = lazy(() => import('./components/FourthLayer'));

function HomePage(){

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Header />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <FirstLayer />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <SecondLayer />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <ThirdLayer />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <FourthLayer />
      </Suspense>
      <Footer />
    </>
  )
}

export default HomePage;